/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const deliveryOutcomeSchema = z.enum(['sent', 'skipped', 'failed'])

export type DeliveryOutcomeSchema = z.infer<typeof deliveryOutcomeSchema>
